export function formatCurrencyWithSymbol(
  value: number | string | null | undefined,
  currency: string,
): string {
  if (value === null || value === undefined) return "-";

  const numericValue = typeof value === "string" ? Number(value) : value;
  if (!Number.isFinite(numericValue)) {
    return "-";
  }

  return new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: currency || "ARS",
    minimumFractionDigits: 2,
  }).format(numericValue);
}